import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { form, FormField, minLength, pattern, required, submit, validate } from '@angular/forms/signals';
import { HttpErrorResponse } from '@angular/common/http';
import { ProfileService } from '../profile.service';
import { CommonService } from 'src/app/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorService } from 'src/app/common/errors/error.service';

interface PasswordFormData {
  password: string;
}

@Component({
  selector: 'app-profile-home',
  templateUrl: './profile-home.component.html',
  styleUrl: './profile-home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormField],
})
export class ProfileHomeComponent {
  private profileService = inject(ProfileService);
  private commonService = inject(CommonService);
  private toastr = inject(ToastrService);
  private errorService = inject(ErrorService);

  passwordModel = signal<PasswordFormData>({ password: '' });

  passwordForm = form(this.passwordModel, (p) => {
    required(p.password, { message: 'Password skal udfyldes.' });
    minLength(p.password, 7, { message: 'Password skal være mindst 7 tegn langt.' });
    pattern(p.password, /\d/, { message: 'Password skal indeholde mindst et tal.' });
    pattern(p.password, /[a-z]/, { message: 'Password skal indeholde mindst et lille bogstav.' });
    pattern(p.password, /[A-Z]/, { message: 'Password skal indeholde mindst et stort bogstav.' });
    pattern(p.password, /[½!"#¤%&/()=?§@£$€\{\[\]\}]/, { message: 'Password skal indeholde mindst et specialtegn. (½!"#¤%&/()=?§@£$€{}[])' });
  });

  onSubmit(event: Event): void {
    event.preventDefault();
    submit(this.passwordForm, async () => {
      const { password } = this.passwordModel();
      this.commonService.confirm(
        'Sæt administator kodeord',
        'Administrator kodeord overskriver dit kodeord for alle dine logins til forskellige kunder, på nuværende miljø.',
        'Ja', 'Nej', 'lg'
      ).then((confirmed) => {
        if (confirmed) {
          this.profileService.setAdminPassword(password)
            .then((result) => {
              if (result) {
                this.toastr.success('Administrator kodeord er sat');
              } else {
                this.errorService.notify('Der skete en fejl under forsøg på at sætte administrator kodeord');
              }
            })
            .catch((_error: HttpErrorResponse) => {
              // HTTP-fejl vises globalt af GlobalErrorInterceptor/ErrorService
            });
        }
      });
    });
  }
}
